<app-dialog-wrapper [data]="data" actionStyleCls="center" (onSubmit)="submit($event)">
</app-dialog-wrapper>
